import { useState, useEffect, useMemo } from "react";
import {
  Kaaba1Icon,
  Mosque2Icon,
  UserSearch1Icon,
  UserUnlock01Icon,
  // Import the new selected state icons
  KaabaSelectedIcon,
  MosqueMadinaSelectedIcon,
  UserSerachSelectedIcon,
  UserUnlockSelectedIcon,
} from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useCustomContext } from "../../_helper/customizer";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../utils/hooks/usePermissions";
import { SystemsDropDown } from "../SystemsDropDown/SystemsDropDown";

const DropdownList = (props) => {
  const { direction } = props;
  const { platform } = useCustomContext();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(platform);
  const { t } = useTranslation();
  const {
    canAccessMakkah,
    canAccessMadina,
    canAccessSeasonalHR,
    canAccessUserManagement,
  } = usePermissions();

  // Platform configuration with permission checks
  const platformConfig = useMemo(() => {
    const config = {};

    // Only add platforms the user has access to
    if (canAccessMakkah()) {
      config.makkah = {
        icon: <Kaaba1Icon />,
        selectedIcon: <KaabaSelectedIcon />,
        name: t("DROPDOWN_MAKKAH_PLATFORM"),
        path: "/app/makkah",
      };
    }

    if (canAccessMadina()) {
      config.madina = {
        icon: <Mosque2Icon />,
        selectedIcon: <MosqueMadinaSelectedIcon />,
        name: t("DROPDOWN_MADINAH_PLATFORM"),
        path: "/app/madina",
      };
    }

    if (canAccessSeasonalHR()) {
      config["seasonal_hr"] = {
        icon: <UserSearch1Icon />,
        selectedIcon: <UserSerachSelectedIcon />,
        name: t("DROPDOWN_SEASONAL_RECRUITMENT_PLATFORM"),
        path: "/app/seasonal_hr",
      };
    }

    if (canAccessUserManagement()) {
      config["user_management"] = {
        icon: <UserUnlock01Icon />,
        selectedIcon: <UserUnlockSelectedIcon />,
        name: t("DROPDOWN_USERS_MANAGEMENT_PLATFORM"),
        path: "/app/user_management/users",
      };
    }

    return config;
  }, [
    canAccessMakkah,
    canAccessMadina,
    canAccessSeasonalHR,
    canAccessUserManagement,
    t,
  ]);

  // Get all platforms for select options
  const allPlatforms = Object.entries(platformConfig);

  // Handle platform change
  const handleChange = (value) => {
    setSelectedValue(value);
    const selectedPlatform = platformConfig[value];

    if (selectedPlatform) {
      navigate(selectedPlatform.path);
    }
  };

  // Update selected value when platform context changes
  useEffect(() => {
    setSelectedValue(platform);
  }, [platform]);

  // Don't render the dropdown if user has no access to any platform
  if (allPlatforms.length === 0) {
    return null;
  }
  return (
    <SystemsDropDown
      allPlatforms={allPlatforms}
      onChange={handleChange}
      value={selectedValue}
      direction={direction}
    />
  );
};

export default DropdownList;
